import { render, staticRenderFns } from "./base-debtor-search.vue?vue&type=template&id=5f719bfc"
import script from "./base-debtor-search.vue?vue&type=script&lang=js"
export * from "./base-debtor-search.vue?vue&type=script&lang=js"
import style0 from "./base-debtor-search.vue?vue&type=style&index=0&id=5f719bfc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports